
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.media-card {
  gap: 2.5rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

@media (min-width: 768px) {

  .media-card {
    display: flex;
  }

  .media-card {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
}

.media-card__content {
  width: 100%;
}

@media (min-width: 768px) {

  .media-card__content {
    width: 66.666667%;
  }
}

.media-card__media {
  width: 100%;
}

@media (min-width: 768px) {

  .media-card__media {
    width: 33.333333%;
  }
}

.media-card__media {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

@media (min-width: 768px) {

  .media-card__media {
    justify-content: flex-end;
  }
}

.media-card__media idb-icon {
  position: absolute;
  z-index: 50;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
  top:41%;
  left:41%;
  filter:drop-shadow(0 0 0.75rem var(--blue-responsible-lighten-3));
}

.media-card__media a{
  display:block;
  position:relative;
  max-width:350px;
}

.media-card__media a:hover idb-icon {
  color: var(--blue-responsible-darken-2);
}

.media-card__media--rounded ::slotted(img) {
  width: 100%;
  border-radius: 0.5rem;
}

.media-card__button {
  margin-top: 3rem;
}

.media-card__heading {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {

  .media-card__heading {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .media-card__heading {
    margin-bottom: 1rem;
  }
}

idb-heading {
  color: var(--blue-responsible-darken-2);
}

.theme--blue-lighten-1 idb-heading {
  color: var(--neutral-white);
}

.theme--blue-lighten-1 .media-card__summary {
  color: var(--neutral-white);
}

.media-position--right .media-card__content {
  order: 1;
}

.media-position--right .media-card__media {
  order: 2;
}

.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 40;
  height: 98.5%;
  width: 100%;
}

@media (min-width: 768px) {

  .overlay {
    height: 100%;
  }
}

.overlay {
  background-color: var(--gray-professional-darken-2);
  opacity: 0.4;
}

.media-card__media--rounded .overlay {
  border-radius: 0.5rem;
}

.media-card__summary{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
}

outline-video-youtube,
outline-video-vimeo{
  display:block;
  position:relative;
}
`;